import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import moment from 'moment';
import {
  Form,
  Grid,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  FieldGroup,
  Panel,
  Table,
  Modal,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ViewProfile.css';
import FontAwesome from 'react-icons/fa';

import { connect } from 'react-redux';

import {
  openReportUserModal,
  openThankYouModal,
} from '../../actions/modalActions';
import ReportUserModal from '../ReportUserModal';

import ThankYouModal from '../ThankYouModal';

// Component
import Reviews from './Reviews';
import VerifiedInfo from '../VerifiedInfo';
import Link from '../Link';
import Avatar from '../Avatar';

// Locale
import messages from '../../locale/messages';
import { Text, Whitespace, View } from '../../components_new/common';
import { buildAvatarPath } from '../../helpers/photoutils';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import Ratings from '../../components_new/common/Ratings';
import { Query } from 'react-apollo';
import UserListings from './userListings.graphql';
import UserReviews from './userReviews.graphql';
import Loader from '../Loader/Loader';
import { Slide } from '../../components_new/CardList';
import { getp } from '../../helpers/getProp';
import Button from '../../components_new/common/FormComponents/Button';
import ReviewItem from '../Reviews/ReviewItem';

@observer
class ViewProfile extends React.Component {
  @observable listingsFocused = true;

  static propTypes = {
    data: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
      location: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
      picture: PropTypes.string.isRequired,
      profileId: PropTypes.number.isRequired,
      reviewsCount: PropTypes.number.isRequired,
    }).isRequired,
    isUser: PropTypes.bool,
    formatMessage: PropTypes.func,
  };

  static defaultProps = {
    data: {
      createdAt: new Date(),
      picture: null,
    },
    isUser: false,
  };

  get isFullyConfirmed() {
    const { data } = this.props;
    return (
      data.isEmailConfirmed &&
      data.isPhoneVerified &&
      data.isFacebookConnected &&
      data.isIdVerification
    );
  }

  render() {
    const {
      data,
      isUser,
      openReportUserModal,
      profileId,
      userData,
      isAuthenticate,
    } = this.props;
    const date = moment(data.createdAt).format('MMMM YYYY');

    return (
      <div className="f f-1 f-columns p-l">
        <div className="w-225">
          <div className="brad-m relative">
            <img
              src={buildAvatarPath(data.picture, null)}
              className="cover h-225 w-225 brad-tl-mx brad-tr-mx"
            />
            <View
              className="absolute left-0 right-0 bottom--30 f f-cc"
              if={this.isFullyConfirmed}
            >
              <div className="bg-white z-10 brad-full b-1 b-primaryDark h-60 w-60 f f-cc">
                <img
                  src="/images/shield.svg"
                  className="primaryDark h-60 w-45 "
                />
              </div>
            </View>
          </div>
          <div className="b-0 bl-1 br-1 bb-1 b-coolGrayLightest brad-bl-mx brad-br-mx p-l">
            <Whitespace smaller2 />
            <div className="f f-columns f-between-center">
              <View className="f-1 mr-s">
                <Text t-l>{data.firstName + ' ' + data.lastName[0]}</Text>
              </View>
              <View className="f-1 o-hidden">
                <Text coolGray>{data.location}</Text>
              </View>
            </div>
            <Text coolGray>
              Member since {moment(data.createdAt).format('MMM YYYY')}
            </Text>
            <Whitespace />
            <div className="f f-columns f-between-center">
              <Text t-l>Email</Text>
              <View if={data.isEmailConfirmed}>
                <Verified />
              </View>
            </div>
            <div className="f f-columns f-between-center">
              <Text t-l>Phone</Text>
              <View if={data.isPhoneVerified}>
                <Verified />
              </View>
            </div>
            <div className="f f-columns f-between-center">
              <Text t-l>Gov I.D.</Text>
              <View if={data.isIdVerification}>
                <Verified />
              </View>
            </div>
          </div>
        </div>
        <div className="f-1 ">
          <div className="f f-columns f-between-center mx-l">
            <div
              className={`b-0 bb-1 brad-m b-${
                this.listingsFocused ? 'primaryDark' : 'coolGrayLightest'
              } px-mxx pb-mxx f-1 f f-columns f-between-center pointer`}
              onClick={() => (this.listingsFocused = true)}
            >
              <Text clickable t-l>
                Listings{' '}
              </Text>
              <Text clickable t-m>
                {data.publishedListingsCount}
              </Text>
            </div>
            <div className="w-16" />
            <div
              className={`b-0 bb-1 brad-m b-${
                this.listingsFocused ? 'coolGrayLightest' : 'primaryDark'
              } px-mxx pb-mxx f-1 f f-columns f-between-center pointer`}
              onClick={() => (this.listingsFocused = false)}
            >
              <Text clickable t-l>
                Reviews
              </Text>
              <View className="f f-columns f-start-center">
                {data.reviewsCount > 0 && data.reviewsCount ? (
                  <Ratings
                    medium
                    rating={data.reviewsStarRating}
                    name="item-card-ratings"
                  />
                ) : null}
                <Text
                  clickable
                  ml={data.reviewsCount > 0 ? 2 : 0}
                  label
                  light
                  grayMedium
                  name="item-card-review-count"
                >
                  {(data.reviewsCount > 0 && data.reviewsCount) || 'no reviews'}
                </Text>
              </View>
            </div>
          </div>
          <div className="f-1 py-l mx-mx">
            {this.listingsFocused && (
              <Query query={UserListings} variables={{ profileId }}>
                {({ data, loading, fetchMore }) => {
                  if (loading) {
                    return <Loader />;
                  } else if (getp(data, 'userListings.rows')) {
                    const currentPage = Math.ceil(
                      data.userListings.rows.length / 24, //Must match userListings.graphql limitOverride
                    );
                    return (
                      <div className="g g-tc-175 g-g-mxx ">
                        {data.userListings.rows.map((x, i) => (
                          <Slide
                            item={x}
                            width={200}
                            currentIndex={i}
                            slideCount={5}
                            position={i}
                          />
                        ))}
                        <View
                          className="f f-cc"
                          if={currentPage < data.userListings.totalPages}
                        >
                          <Button
                            primary
                            action
                            onClick={() =>
                              fetchMore({
                                variables: {
                                  profileId,
                                  currentPage, //0 based paging
                                },
                                updateQuery: (prev, { fetchMoreResult }) => {
                                  if (!fetchMoreResult) return prev;
                                  const itms = [
                                    ...prev.userListings.rows,
                                    ...fetchMoreResult.userListings.rows,
                                  ];
                                  const newL = Object.assign(
                                    {},
                                    prev,
                                    fetchMoreResult,
                                  );
                                  newL.userListings.rows = itms;
                                  return newL;
                                },
                              })
                            }
                          >
                            ...more
                          </Button>
                        </View>
                      </div>
                    );
                  }
                  return <div>Whoops</div>;
                }}
              </Query>
            )}
            {!this.listingsFocused && (
              <div className="px-mxx">
                <Query query={UserReviews} variables={{ profileId }}>
                  {({ data, loading, fetchMore }) => {
                    if (loading) {
                      return <Loader />;
                    } else if (getp(data, 'userReviews.rows')) {
                      const currentPage = Math.ceil(
                        data.userReviews.rows.length / 6,
                      );
                      return (
                        <div className="g g-tc-a-2 g-g-mxx ">
                          {data.userReviews.rows.map((x, i) => (
                            <ReviewItem
                              key={i}
                              picture={x.authorData.picture}
                              firstName={x.authorData.firstName}
                              lastName={x.authorData.lastName}
                              profileId={x.authorData.profileId}
                              reviewContent={x.reviewContent}
                              createdAt={x.createdAt}
                              response={x.response}
                              rating={x.rating}
                            />
                          ))}
                          <View
                            className="f f-cc"
                            if={currentPage < data.userReviews.totalPages}
                          >
                            <Button
                              primary
                              action
                              onClick={() =>
                                fetchMore({
                                  variables: {
                                    profileId,
                                    currentPage, //0 based paging
                                  },
                                  updateQuery: (prev, { fetchMoreResult }) => {
                                    if (!fetchMoreResult) return prev;
                                    const itms = [
                                      ...prev.userReviews.rows,
                                      ...fetchMoreResult.userReviews.rows,
                                    ];
                                    const newL = Object.assign(
                                      {},
                                      prev,
                                      fetchMoreResult,
                                    );
                                    newL.userReviews.rows = itms;
                                    return newL;
                                  },
                                })
                              }
                            >
                              ...more
                            </Button>
                          </View>
                        </div>
                      );
                    }
                    return <div>Whoops</div>;
                  }}
                </Query>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  listSettingsData: state.adminListSettingsData.data,
  userData: state.account.data,
  isAuthenticate: state.runtime.isAuthenticated,
});

const mapDispatch = {
  openReportUserModal,
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(ViewProfile),
);

function Verified() {
  return (
    <View>
      <Text primaryDark t-s inline mr={2}>
        verified
      </Text>
      <i className="fa fa-check-circle primary" />
    </View>
  );
}



// WEBPACK FOOTER //
// ./src/components/ViewProfile/ViewProfile.js